/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import ReactTable from 'react-table-legacy'
import "react-table-legacy/react-table.css";

import { Menu, Item, contextMenu } from 'react-contexify';
import 'react-contexify/ReactContexify.css';

import ConfirmationModal from '../widgets/ConfirmationModal'

import {AppContext} from '../AppContext';

class VaultViewData extends React.Component
{
  vaultViewContextMenu = null;
  newImmutableState = null;  
  closeConfirmationModal = null;
  tablePageSizeLS = undefined;

  componentDidMount()
  {
    let tablePageSize = (Number(this.context.appLocalStorage.getItem(this.tablePageSizeLS)));
    this.setState({ tablePageSize: 0 === tablePageSize ? undefined : tablePageSize }); 
  }

  constructor(props)
  {
    super();

    this.vaultViewContextMenu = 'vaultViewContextMenu.' + props.tabIndex;
    this.debouncedSaveColumnWidths = window.debounce(props.saveColumnWidths, 500);    
    this.tablePageSizeLS = 'vaultViewTab.' + props.tabIndex + '.tablePageSize';

    this.state =
    {
      displayPlayItem: 'none',
      downloadLink: null,
      modalText: undefined,
      confirmationModalIsOpen: false,
      tablePageSize: 20
    }

    // need to add these below for use in context menu
    this.openDetailsModal = this.openDetailsModal.bind(this);
    this.openKeywordsModal = this.openKeywordsModal.bind(this);
    this.slideshowHandler = this.slideshowHandler.bind(this);
    this.sortChanged = this.sortChanged.bind(this);
    this.contextMenuHandler = this.contextMenuHandler.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.purgeItem = this.purgeItem.bind(this);
    this.restoreItem = this.restoreItem.bind(this);
    this.removeKeywords = this.removeKeywords.bind(this);
    this.secureWeblinkHandler = this.secureWeblinkHandler.bind(this);
    this.shareObjects = this.shareObjects.bind(this);
    this.toggleImmutableConfirmed = this.toggleImmutableConfirmed.bind(this);
    this.openWithHelper = this.openWithHelper.bind(this);
    this.pageSizeChanged = this.pageSizeChanged.bind(this);
    this.generateEmbeddings = this.generateEmbeddings.bind(this);
  }

  /**
  * Pops up a context menu on the vault table
  *
  */
  async contextMenuHandler(event, handleOriginal, rowInfo, column, instance)
  {
    event.preventDefault();

    for (let x = 0; x < this.props.selectedRows.length; x++)
    {
      if (rowInfo.index === this.props.selectedRows[x])
      {
        if (1 === this.props.selectedRows.length && 'deleted' !== this.props.viewType)
        {
          event.persist();
          let bodyData = {};
          bodyData.objectId = this.props.vaultViewData[this.props.selectedRows[0]].objectId;
          bodyData.disposition = 'DOWNLOAD';
    
          let result = await this.context.dbTwig.callRestAPI('dgBunker', 'generateObjectWeblink', bodyData);
          if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error generating weblink');
          this.setState({downloadLink: result.jsonData.objectWeblink});
        }

        this.showContextMenu(event, rowInfo);
        return;
      }
    }

    if ('deleted' !== this.props.viewType)
    {
      event.persist();
      let bodyData = {};
      bodyData.objectId = rowInfo.row.objectId;
      bodyData.disposition = 'DOWNLOAD';

      let result = await this.context.dbTwig.callRestAPI('dgBunker', 'generateObjectWeblink', bodyData);
      if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error generating weblink');
      this.setState({downloadLink: result.jsonData.objectWeblink});
    }

    this.props.selectionHandler(event, rowInfo, instance, this.showContextMenu.bind(this, event, rowInfo));
  }
 
  debouncedSaveColumnWidths = null;

  /**
    * Deletes or restores all currently selected objects
    *
    */


  deleteItem()
  {
    let modalText = 'Are you sure you want to delete the selected items?'
    this.closeConfirmationModal = this.deleteItemConfirmed.bind(this);
    this.setState({modalText: modalText, confirmationModalIsOpen: true})
  }

  deleteItemConfirmed(confirmed)
  {
    this.setState({confirmationModalIsOpen: false});
    if (!confirmed) return;

    this.props.deleteRestoreOrPurge('delete');
  }

  doubleClickForDetails(rowInfo)
  {
    this.props.openDetailsModal(rowInfo.original, rowInfo.index);
  }

  generateEmbeddings()
  {
    this.props.generateEmbeddings();
  }

  noDataComponent()
  {
    return null;
  }

  openDetailsModal(event, props)
  {
    this.props.openDetailsModal(this.props.vaultViewData[this.props.selectedRows[0]], this.props.selectedRows[0]);
  }

  openKeywordsModal(event, props)
  {
    this.props.keywordsButtonHandler(event.props.rowInfo.row);
  }

  async openWithHelper(event)
  {
    let bodyData = {};
    bodyData.objectId = this.props.vaultViewData[this.props.selectedRows[0]].objectId;
    bodyData.contentDisposition = 'STREAM';

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'generateObjectWeblink', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error generating weblink');

    bodyData = {};
    bodyData.gatewayName = this.context.appLocalStorage.getGatewayName();
    bodyData.commandLine = window.getHelperApp(this.props.vaultViewData[this.props.selectedRows[0]].mimeType) + 
      ' ' + result.jsonData.objectWeblink;

    result = await this.context.dbTwig.callRestAPI('dgBunker', 'spawnHelperApplication', bodyData);
    if ('success' !== result.status && this.context.dbTwig.GatewayOffline !== result.errorCode) 
      return this.context.dbTwig.apiErrorHandler(result, 'Error spawning helper app.');

    if ('success' !== result.status && this.context.dbTwig.GatewayOffline === result.errorCode)
      this.context.postNotification('warning', 'Gateway offline.');

    if ('success' === result.status) this.context.postNotification('success', 'Helper application spawned.');
  }

  pageSizeChanged(pageSize)
  {
    this.context.appLocalStorage.setItem(this.tablePageSizeLS, pageSize);
    this.setState({ tablePageSize: pageSize });
  }

  purgeItem()
  {
    let modalText = 'Are you sure you want to purge the selected items?  Once purged, they can not be recovered.';
    this.closeConfirmationModal = this.purgeItemConfirmed.bind(this);
    this.setState({modalText: modalText, confirmationModalIsOpen: true})
  }

  purgeItemConfirmed(confirmed)
  {
    this.setState({confirmationModalIsOpen: false});
    if (!confirmed) return;

    this.props.deleteRestoreOrPurge('purge');
  }

  removeKeywords()
  {
    let modalText = 'Are you sure you want to remove all of the keywords for the selected items?';
    this.closeConfirmationModal = this.removeKeywordsConfirmed.bind(this);
    this.setState({modalText: modalText, confirmationModalIsOpen: true})
  }

  removeKeywordsConfirmed(confirmed)
  {
    this.setState({confirmationModalIsOpen: false});
    if (!confirmed) return;

    this.props.removeKeywords();
  }

  render()
  {
    let defaultSorted = [];

    if (undefined !== this.props.vaultViewData) defaultSorted = this.props.sortColumn;

    var viewPlayItem = <Item onClick={this.slideshowHandler}>Play/View</Item>;
    var setImmutableItem = <Item onClick={this.toggleImmutable.bind(this, 'Y', 'object')}>Set Immutable Obj.</Item>;
    var unsetImmutableItem = <Item onClick={this.toggleImmutable.bind(this, 'N', 'object')}>Unset Immutable Obj.</Item>;
    var setImmutableKeywords = <Item onClick={this.toggleImmutable.bind(this, 'Y', 'keywords')}>Set Immutable Keys</Item>;
    var unsetImmutableKeywords = <Item onClick={this.toggleImmutable.bind(this, 'N', 'keywords')}>Unset Immutable Keys</Item>;
    var openWithHelperItem = ('' !== this.context.appLocalStorage.getGatewayName() ?
      <Item onClick={this.openWithHelper}>Open With Helper App.</Item> : null);
    const detailMenuItem = (this.props.selectedRows.length > 1 ? null : <Item onClick={this.openDetailsModal}>Details</Item>);
    var secureWeblinkItem = (this.props.selectedRows.length > 1 ? null : <Item onClick={this.secureWeblinkHandler}>Secure Weblink</Item>);
    var slideshowItem = (this.props.selectedRows.length > 1 ? <Item onClick={this.slideshowHandler}>Slideshow</Item> : null);
    
    var downloadItem = (this.props.selectedRows.length === 1 && this.props.vaultViewData.length !== 0 ? 
      <Item >
        <a href={this.state.downloadLink} download={this.props.vaultViewData[this.props.selectedRows[0]].objectName}>
          Download
        </a>
      </Item> : null);
    
    var keywordsItem = <Item onClick={this.openKeywordsModal}>Keywords</Item>;
    var removeKeywordsItem = <Item onClick={this.removeKeywords}>Remove Keywords</Item>;
    var restoreItem = <Item onClick={this.restoreItem}>Restore</Item>;
    var purgeItem = <Item onClick={this.purgeItem}>Purge</Item>;
    var deleteItem = <Item onClick={this.deleteItem}>Delete</Item>;
    var shareItem = (this.context.userSession.shareObjectsEnabled(this.context.userUiProfile.grantedPermissions) ? <Item onClick={this.shareObjects}>Sharing</Item> : null);
  
    var generateEmbeddingsItem = null;

    if (window.extensionEnabled(this.context.websiteProfile.installedExtensions, this.context.extensions.AI))
    {
      for (let x = 0; x < this.props.selectedRows.length; x++)
      {
        if (null !== this.props.vaultViewData[this.props.selectedRows[x]].vectorModality &&
            'Generating' !== this.props.vaultViewData[this.props.selectedRows[x]].embeddingsGenerated &&
            'Request Submitted' !== this.props.vaultViewData[this.props.selectedRows[x]].embeddingsGenerated 
        )
        {
          generateEmbeddingsItem = <Item onClick={this.generateEmbeddings}>Generate Embeddings</Item>;
          break;
        }
      }
    }      

    var immutableObjectSelected = false;
    for (let x = 0; x < this.props.selectedRows.length; x++)
    {
      if ('Y' === this.props.vaultViewData[this.props.selectedRows[x]].immutableObject)
      {
        immutableObjectSelected = true;
        break;
      }
    }
    
    var immutableKeywordsSelected = false;
    for (let x = 0; x < this.props.selectedRows.length; x++)
    {
      if ('Y' === this.props.vaultViewData[this.props.selectedRows[x]].immutableKeywords)
      {
        immutableKeywordsSelected = true;
        break;
      }
    }
    
    switch (this.props.selectedRows.length)
    {
      case 0:
        setImmutableItem = null;
        unsetImmutableItem = null;
        setImmutableKeywords = null;
        unsetImmutableKeywords = null;
        openWithHelperItem = null;
        break;

      case 1:
        if ('Player' !== this.props.vaultViewData[this.props.selectedRows[0]].htmlElement && 
            'object' !== this.props.vaultViewData[this.props.selectedRows[0]].htmlElement &&
            'img' !== this.props.vaultViewData[this.props.selectedRows[0]].htmlElement)
          viewPlayItem = null;

        if ('Y' === this.props.vaultViewData[this.props.selectedRows[0]].immutableObject)
          setImmutableItem = null;
        else
          unsetImmutableItem = null;

        if ('Y' === this.props.vaultViewData[this.props.selectedRows[0]].immutableKeywords)
          setImmutableKeywords = null;
        else
          unsetImmutableKeywords = null;

        if (undefined === window.getHelperApp(this.props.vaultViewData[this.props.selectedRows[0]].mimeType))
          openWithHelperItem = null;

        break;

      default:
        viewPlayItem = null;
        openWithHelperItem = null;
        let firstValue = this.props.vaultViewData[this.props.selectedRows[0]].immutableObject;
        let x = 1;
        for (; x < this.props.selectedRows.length; x++)
          if (firstValue !== this.props.vaultViewData[this.props.selectedRows[x]].immutableObject) break;
  
        if (x === this.props.selectedRows.length)
        {
          if ('Y' === firstValue)
            setImmutableItem = null;
          else
            unsetImmutableItem = null;
        }

        firstValue = this.props.vaultViewData[this.props.selectedRows[0]].immutableKeywords;
        x = 1;
        for (; x < this.props.selectedRows.length; x++)
          if (firstValue !== this.props.vaultViewData[this.props.selectedRows[x]].immutableKeywords) break;
  
        if (x === this.props.selectedRows.length)
        {
          if ('Y' === firstValue)
            setImmutableKeywords = null;
          else
            unsetImmutableKeywords = null;
        }
        break;
    }

    if (immutableObjectSelected)
    {
      restoreItem = null;
      purgeItem = null;
      deleteItem = null;
    }

    if (immutableKeywordsSelected) removeKeywordsItem = null;

    switch (this.props.viewType)
    {
      case 'cataloged':
        restoreItem = null;
        purgeItem = null;
        break;

      case 'uncataloged':
        removeKeywordsItem = null;
        restoreItem = null;
        purgeItem = null;
        break;
        
      case 'deleted':
        openWithHelperItem = null;
        deleteItem = null;
        downloadItem = null;
        viewPlayItem = null;
        secureWeblinkItem = null; 
        slideshowItem = null;
        removeKeywordsItem = null; 
        shareItem = null;
        setImmutableItem = null;
        unsetImmutableItem = null;
        setImmutableKeywords = null;
        unsetImmutableKeywords = null;
        generateEmbeddingsItem = null;
        break;
    
      case 'shared':
        removeKeywordsItem = null;
        deleteItem = null;
        shareItem = null;
        setImmutableItem = null;
        unsetImmutableItem = null;
        setImmutableKeywords = null;
        unsetImmutableKeywords = null;
        restoreItem = null;
        purgeItem = null;
        generateEmbeddingsItem = null;
        break;

      default:
        break;
    }
    
    return(
      <div>
        <ReactTable data={this.props.vaultViewData} showPagination={true} columns={this.props.vaultColumns} minRows={1} className="-highlight"
          NoDataComponent={this.noDataComponent} pageSizeOptions={[5, 10, 15, 20, 30, 50, 100]} defaultPageSize={this.state.tablePageSize}
          onSortedChange={this.sortChanged} filterable={this.props.enableColumnFilters} defaultSorted={defaultSorted} showPageJump={false}
          getTrProps={(state, rowInfo, column) => 
          { 
            if (rowInfo === undefined) return { };                
            let x = this.props.selectedRows.indexOf(rowInfo.index);
            if (-1 === x) 
              return {} 
            else
              return {style: {fontWeight: "bold", color: "#ffffff", backgroundColor: "#0275d8"}} // #0275d8 matches reactstrap, #00abc7 matches uploader theme
          }}
          getTdProps={(state, rowInfo, column, instance) => {
            let whiteSpace = 'no-wrap';
            return {
              onDoubleClick: this.doubleClickForDetails.bind(this, rowInfo),
              onClick: (e, handleOriginal) => {this.props.selectionHandler(e, rowInfo, instance)},
              onContextMenu: (event, handleOriginal) => {this.contextMenuHandler(event, handleOriginal, rowInfo, column, instance)},
              style: {whiteSpace: whiteSpace},
            }
          }}
          onResizedChange={(resizedColumns, event) => this.debouncedSaveColumnWidths(resizedColumns, event)}
          onPageSizeChange={this.pageSizeChanged}
          ref={r => this.props.setTableRef(r, this.props.tabIndex)} pageSize={this.state.tablePageSize}
        />
        <Menu id={this.vaultViewContextMenu}> 
          {detailMenuItem}
          {keywordsItem}
          {downloadItem}
          {openWithHelperItem}
          {generateEmbeddingsItem}
          {shareItem}
          {setImmutableItem}
          {unsetImmutableItem}
          {setImmutableKeywords}
          {unsetImmutableKeywords}
          {deleteItem}
          {secureWeblinkItem}
          {slideshowItem}
          {viewPlayItem}
          {restoreItem}
          {purgeItem}
          {removeKeywordsItem}
        </Menu>
        <ConfirmationModal modalIsOpen={this.state.confirmationModalIsOpen} closeModal={this.closeConfirmationModal} 
          modalText={this.state.modalText}
        />
      </div>
    );
  }

  restoreItem()
  {
    let modalText = 'Are you sure you want to restore the selected items?';
    this.closeConfirmationModal = this.restoreItemConfirmed.bind(this);
    this.setState({modalText: modalText, confirmationModalIsOpen: true})
  }

  restoreItemConfirmed(confirmed)
  {
    this.setState({confirmationModalIsOpen: false});
    if (!confirmed) return;

    this.props.deleteRestoreOrPurge('restore');
  }

  secureWeblinkHandler(event, props)
  {
    this.props.secureWeblinkHandler(event);
  }

  shareObjects(event, props)
  {
    this.props.sharingButtonHandler();
  }

  showContextMenu(event, rowInfo)
  {
    contextMenu.show(
    {
      id: this.vaultViewContextMenu,
      event: event,
      props: {rowInfo: rowInfo}
    });
  
  }

  /**
  * View/play a single object or create and view a slideshow
  * for multiple objects
  *
  */
  slideshowHandler()
  {
    if (this.props.selectedRows.length < 1) 
    { 
      this.context.postNotification('info', 'Please select an object first.');
      return;
    }

    this.props.openContentGallery();
  }

  sortChanged(newSorted, column, shiftKey)
  {
    this.props.sortChanged(newSorted);
  }

  toggleImmutable(state, objectsOrKeywords)
  {
    let modalText = ('N' === state ?
      'Are you sure that you want to make the selected object(s) mutable?  Doing so will allow changes to the content and deletion of the object(s).' :
      'Are you sure that you want to make the selected object(s) immutable?  Doing so will prevent all changes to the object(s).');

    if ('keywords' === objectsOrKeywords)
      modalText = ('N' === state ?
        'Are you sure that you want to make the keywords for the selected object(s) mutable? Doing so will allow changes to the keywords and tags associated with the objects(s).' :
        'Are you sure that you want to make the keywords for the selected object(s) immutable? Doing so prevent changes to the keywords and tags associated with the objects(s).');

    this.closeConfirmationModal = this.toggleImmutableConfirmed.bind(this, objectsOrKeywords);
    this.setState({modalText: modalText, confirmationModalIsOpen: true});
    this.newImmutableState = state;
  }

  async toggleImmutableConfirmed(objectsOrKeywords, confirmed)
  {
    this.setState({confirmationModalIsOpen: false});
    if (!confirmed) return;

    var bodyData = {};
    bodyData.objectIds = [];
    for (let x = 0; x < this.props.selectedRows.length; x++)
      bodyData.objectIds[x] = this.props.vaultViewData[this.props.selectedRows[x]].objectId;

    bodyData.objectOrKeywords = objectsOrKeywords;
    bodyData.newState = this.newImmutableState;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'setImmutableState', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error setting/unsetting immutable flag');    
    this.context.postNotification('success', 'Immutable state set for the selected object(s).');
    this.props.refreshVaultViewTab();
  }
}

VaultViewData.contextType = AppContext;

export default VaultViewData